// extracted by mini-css-extract-plugin
module.exports = {"textarea":"TextArea_textarea__1bvIz","danger":"TextArea_danger__3V0tn"};